import config from './config.js'
 

export default {
  methods: {
    qs(key) {
      const array = key.split('.');
      let current = config, value = null;

      for (let i = 0, j = array.length; i < j; i++) {
        const property = array[i];
        value = current[property];
        if (i === j - 1) return value;
        if (!value) return '';
        current = value;
      }
      return '';
    }
  }
};